import { render, staticRenderFns } from "./NodeAllocationPage.vue?vue&type=template&id=748b0f3d&scoped=true&"
import script from "./NodeAllocationPage.vue?vue&type=script&lang=js&"
export * from "./NodeAllocationPage.vue?vue&type=script&lang=js&"
import style0 from "./NodeAllocationPage.vue?vue&type=style&index=0&id=748b0f3d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748b0f3d",
  null
  
)

export default component.exports